export default "__VITE_ASSET__CskARbS___"